import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Box } from '@hub-la/design-system';

let _ = t => t,
  _t,
  _t2;
const ProgressWrapper = styled(Box)(_t || (_t = _`
  overflow: hidden;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`));
const ProgressBar = styled(Box)(_t2 || (_t2 = _`
  position: relative;
`));
const PostProgress = ({
  progress,
  maxProgress,
  viewed
}) => {
  const calcPorcentageProgress = (progress, total) => {
    if (viewed) return 100;
    if (!total || total < 0) return 0;
    if (total === 0 || progress === 0) return 0;
    return progress / total * 100;
  };
  return jsx(ProgressWrapper, Object.assign({
    position: "absolute",
    height: 4,
    left: "0",
    bottom: 0,
    right: "0",
    bgcolor: "#616161"
  }, {
    children: (viewed || maxProgress) && jsx(ProgressBar, {
      position: "relative",
      bgcolor: "#EA3323",
      left: "0",
      bottom: "0",
      right: "0",
      height: 4,
      width: `${calcPorcentageProgress(progress, maxProgress)}%`
    })
  }));
};

export { PostProgress };
